import { CommonModule, JsonPipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../../../Util/Session/session.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import moment from 'moment';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ApprovalTrackingComponent } from '../../../Component/ApprovalTracking/approval-tracking/approval-tracking.component';
import { CommonService } from '../../../Model/Common/common.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';


@Component({
  selector: 'app-leave-history',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NgbDatepickerModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './leave-history.component.html',
  styleUrl: './leave-history.component.scss'
})
export class LeaveHistoryComponent {

  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  user = [] as any;
  EmployeeLeave = [];

  Filter = {
    ModuleMasterId: 5,
    EmpMasterID: null as any,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private leave: LeaveService,
    private session: SessionService,
    private calendar: NgbCalendar,
    private dateFromat: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpMasterID = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    //this.GetEmployeeLeaveDetails();
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.Search();
    } else {
      form.submitted = true;
    }
  }

  Search() {
    if (this.Filter.IsWithdraw) {
      this.ESS_EmployeeLeaveWithdrawLoad();
    } else {
      this.GetEmployeeLeaveDetails();
    }
  }

  GetEmployeeLeaveDetails() {
    this.Filter.EmpMasterID = this.user.UserId;
    if (moment(this.dateFormat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.leave.GetEmployeeLeaveDetails({ ESS_EmployeeLeaveDetailsID: 0, EmpMasterID: this.Filter.EmpMasterID, FromDate: this.dateFormat.format(this.Filter.FromDate), ToDate: this.dateFormat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus, SelectType: 1 }).subscribe({
        next: (response) => {
          this.EmployeeLeave = response;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ESS_EmployeeLeaveWithdrawLoad() {
    this.isDisabled = true;
    this.Filter.EmpMasterID = this.user.UserId;
    this.leave.ESS_EmployeeLeaveWithdrawLoad({ SelectType: 1, EmpMasterID: this.Filter.EmpMasterID, ESS_EmployeeLeaveDetailsID: 0 }).subscribe({
      next: (response) => {
        this.EmployeeLeave = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Tracking(Id: number) {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['EmpMasterID'];
    modalRef.componentInstance.Detail.TransactionId = this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['TransactionId'];
    modalRef.componentInstance.Detail.UserImage = this.common.PhotoLink(this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['Photo']);
    modalRef.componentInstance.Detail.EmployeeName = this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['FullName'];
    modalRef.componentInstance.Detail.EmpCode = this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['EmpCode'];
    modalRef.componentInstance.Detail.DesignationName = this.EmployeeLeave.filter((e: any) => e.EmployeeLeaveDetailsID == Id)[0]['DesignationName'];

    modalRef.result.then(result => { });
  }

  async SaveEmployeeLeaveDetails(index: any) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsView) {
        if (result) {
          this.isDisabled = true;
          this.leave.SaveEmployeeLeaveDetails({ SelectType: 'WITHDRAWN', ESS_EmployeeLeaveDetailsID: this.EmployeeLeave[index]['EmployeeLeaveDetailsID'] }).subscribe({
            next: (response) => {
              if (response.Error_Code == '404') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.GetEmployeeLeaveDetails();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          // this.Filter.FromDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          // this.Filter.ToDate = this.dateFormat.parse(response.Table[0].RegistrationDate);

          // this.Filter.FromDate.day = 1;
          // this.Filter.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
          this.Filter.FromDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDate.day = 1;
          this.Filter.FromDate.month = 1;
          this.Filter.ToDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate.day = 31;
          this.Filter.ToDate.month = 12;
        }
        this.Search();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.EmployeeLeave = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}


